// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nJLFDjN546IzZf {
  color: var(--ds-text-subtlest, #626f86);
}
.nJLFDjN546IzZf:hover,
.nJLFDjN546IzZf:active {
  color: var(--ds-text-subtlest, #626f86);
}
.CLFtg2CekA7yNc {
  /* stylelint-disable declaration-no-important */
  margin: var(--ds-space-0, 0px) var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-negative-025, -2px) !important;
  /* stylelint-enable declaration-no-important */
  /* stylelint-disable-next-line declaration-no-important */
  padding: var(--ds-space-025, 2px) !important;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardIsComplete": `nJLFDjN546IzZf`,
	"doneStateButton": `CLFtg2CekA7yNc`
};
export default ___CSS_LOADER_EXPORT___;
